import Image from "next/image";
import Link from "next/link";
import { withBase } from "@/lib/base-path";
import { cn } from "@/lib/utils";

/** Logo Kementerian Kesehatan RI (rasio asli 692×747). */
export function BrandMark({ className }: { className?: string }) {
  return (
    <Image
      src={withBase("/logo-kemenkes.png")}
      alt=""
      width={37}
      height={40}
      priority
      className={cn("h-10 w-auto shrink-0", className)}
    />
  );
}

export function Brand({
  title,
  subtitle = "Kementerian Kesehatan RI",
  href = "/",
  inverted = false,
}: {
  title?: string;
  subtitle?: string;
  href?: string;
  /** Untuk latar gelap (sidebar internal, panel login). */
  inverted?: boolean;
}) {
  const compact = title === undefined;
  return (
    <Link
      href={href}
      className={cn("flex items-center gap-3 no-underline", inverted ? "text-white" : "text-foreground")}
    >
      <BrandMark />
      <span className={cn("flex flex-col leading-tight", compact && "whitespace-nowrap")}>
        <span className={cn("font-extrabold", compact ? "text-[13px]" : "text-[15px]")}>
          {title ?? "Kurasi Harga Alkes"}
        </span>
        <span
          className={cn(compact ? "text-[11px]" : "text-xs", inverted ? "text-[#9fb0b9]" : "text-muted-foreground")}
        >
          {subtitle}
        </span>
      </span>
    </Link>
  );
}
